import { render } from "./BannerThree.vue?vue&type=template&id=5a6c1405&scoped=true"
import script from "./BannerThree.vue?vue&type=script&lang=js"
export * from "./BannerThree.vue?vue&type=script&lang=js"

import "./BannerThree.vue?vue&type=style&index=0&id=5a6c1405&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6c1405"]])

export default __exports__